import { configureStore } from '@reduxjs/toolkit'
import vicotryvaultSlice from './victoryvaultData'
import blogSlice from './blogData';

const store = configureStore({
    reducer:{victoryVault:vicotryvaultSlice.reducer, blogs:blogSlice.reducer}
})

export default store;